module.exports = __webpack_public_path__ + "img/active-icon.d14aef0b.svg";